import { insurance } from '@getpopsure/private-constants';
import { englishFormattedEuroCurrency } from '@getpopsure/public-utility';
import classNames from 'classnames';
import { Tariff } from 'components/PrivateQuoteWidget/models';

interface CTACellProps<T extends { tariff?: Tariff }> {
  name: string;
  row: T;
  showPrice?: boolean;
  noButton?: boolean;
}

export const CTACell = <
  T extends { tariff?: Tariff; contribution?: number | string }
>({
  name,
  row,
  showPrice = true,
  noButton = false,
}: CTACellProps<T>) => {
  const priceStr =
    typeof row.contribution === 'number'
      ? englishFormattedEuroCurrency(Math.round(row.contribution), true)
      : row.contribution;

  if (!priceStr || noButton) {
    return <p className="p-h3">{name}</p>;
  }

  const isPublic = name === 'Public';

  return (
    <div className="wmn3">
      <p className="p-h3">
        {name} {showPrice && <span className="tc-purple-500">{priceStr}</span>}
      </p>
      {row.tariff ? (
        <a
          className={classNames('p-btn--primary mt16', {
            'p-btn--secondary-grey': isPublic,
          })}
          href={insurance.privateHealth.preSignup}
        >
          Get covered
        </a>
      ) : (
        <a
          className={classNames('p-btn--primary mt16', {
            'p-btn--secondary-grey': isPublic,
          })}
          href={insurance.publicHealth.landingPage}
          target="_blank"
          rel="noopener noreferrer"
        >
          Get covered
        </a>
      )}
    </div>
  );
};
